import type { BusinessHoursProps } from '../common/business-hours-types';
import {
  BusinessHoursPropsProvider,
  useBusinessHoursProps
} from './business-hours-props-context';
import { CurrentStatusProvider } from './current-status-context';
import { Schedule } from './schedule/schedule';
import { StatusIndicator } from './status-indicator/status-indicator';

export const BusinessHours = ({ ...settings }: Partial<BusinessHoursProps>) => {
  return (
    <BusinessHoursPropsProvider {...settings}>
      <CurrentStatusProvider>
        <BusinessHoursInner />
      </CurrentStatusProvider>
    </BusinessHoursPropsProvider>
  );
};

const BusinessHoursInner = () => {
  const settings = useBusinessHoursProps();
  const { mode } = settings;
  if (mode !== 'hours') {
    return <StatusIndicator {...settings} />;
  }
  return <Schedule insidePopout={false} />;
};
